export enum MeterInfoSuccessState {
    NoLeaver,
    Completed,
    LeaverNotComplete,
}
